import { 
  Component, ElementRef, HostListener, OnInit, QueryList, 
  ViewChild, ViewChildren 
} from '@angular/core';
import { NgbdSortableHeader, SortEvent } from '../../../../../shared/directives/NgbdSortableHeader';
import { Observable } from 'rxjs';
import { EmpresasService } from '../../../../../shared/services/empresas.service';
import { DataService } from "../../../../../shared/services/municipios.service";

import { Utils } from '../../../../../shared/utils/Utils';
const Swal = require("sweetalert2");
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-nueva-empresa',
  templateUrl: './nueva-empresa.component.html',
  styleUrls: ['./nueva-empresa.component.scss']
})
export class NuevaEmpresaComponent implements OnInit {
  public selected = [];
  public searchText = '';
  //total$: Observable<number>;
  propietarios: any[] = [];
  public show: boolean = false;

  openDropdown: any = null;
  openDropdown2: any = null;
  sortColumn: string = '';
  sortDirection: string = 'asc';
  searchTerm: string = '';
  dropdownStates: boolean[] = [];

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  tableItem$: any;
  filteredTableItems!: EmpresasService[];
  
  //conteoPorMes: Record<string, number>;
  empresas: any[] = [];
  editMode: boolean = false;
  empresaselecionada: any;
  formEmpresa!: FormGroup;
  validate: boolean = false;
  errores: any;
  municipios: any[] = []; // Arreglo donde almacenaremos los municipios

  @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;

  pageSize: number = 5;
  page: number = 1;
  //totalItems: number;

  constructor(
    private empresasService: EmpresasService,
    private fb: FormBuilder,
    private dataService: DataService,
  ) {}

  ngOnInit() {
 this.formEmpresa = this.fb.group({
  nit: [''],
  digito: [''],
  nombre: [''],
  direccion: [''],
  ciudad: [''],
  telefono: [''],
  celular: [''],
  email: [''],
  observaciones: [''],
  eps: [false], 
  arl: [false], 
  afp: [false], 
  ces: [false], 
  ccf: [false],
  bancos: [false], 
  transporte: [false], 
  colegio: [false], 
  cda: [false],
  taller: [false], 
  eds: [false], 
  contratista: [false], 
  proveedor: [false],
  aseguradora: [false], 
  almacen: [false], 
  serviteca: [false],
  entidad: [false],
  estado: [1]  
});


    this.cargarCiudades();
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.sortColumn = column;
    this.sortDirection = direction;
  }

  sortData(column: string) {
    this.sortDirection = this.sortColumn === column && this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortColumn = column;

    this.empresas.sort((a, b) => {
      const valueA = a[column] ?? '';
      const valueB = b[column] ?? '';

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      } else {
        return this.sortDirection === 'asc'
          ? valueA.toString().localeCompare(valueB.toString())
          : valueB.toString().localeCompare(valueA.toString());
      }
    });
  }

  get filteredPropietarios() {
    if (!this.searchTerm) return this.empresas;

    const term = this.searchTerm.toLowerCase();
    return this.empresas.filter(emp => 
      emp.nit.toLowerCase().includes(term) || 
      emp.digito.toLowerCase().includes(term) || 
      emp.nombre.toLowerCase().includes(term)
    );
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  validarTipoEmpresaSeleccionado(): boolean {
  const controles = this.formEmpresa.controls;
  const algunoSeleccionado = Object.keys(controles).some(key => controles[key].value === true);
  if (!algunoSeleccionado) {
    this.mostrarAlerta("Campo requerido", "Selecciona al menos un tipo de empresa", "info");
  }
  return algunoSeleccionado;
  }

  guardarEmpresas() {
    this.validate = true;
    const datosEmpresas = { ...this.formEmpresa.value };


    
  
    // Validar el campo email: si no está vacío pero no contiene "@", se muestra alerta y se detiene el envío.
    const emailValue = this.formEmpresa.get('email')?.value;
    if (emailValue && !emailValue.includes('@')) {
      this.mostrarAlerta(
        "Email inválido", 
        "El correo electrónico es inválido. Por favor, ingresa un correo que contenga '@'", 
        "info"
      );
      return;
    }
  
    // Validar campos obligatorios
    if (!this.formEmpresa.get('nit')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un número de documento", "info");
      this.inputNit?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('digito')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un digito de verificación", "info");
      this.inputCodigo?.nativeElement.focus();
      return;
    }
  
    if (!this.formEmpresa.get('nombre')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un nombre", "info");
      this.inputNombre?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('direccion')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una dirección", "info");
      this.inputDireccion?.nativeElement.focus();
      return;
    }
  
    if (!this.formEmpresa.get('ciudad')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa una ciudad", "info");
      this.inputCiudad?.nativeElement.focus();
      return;
    }

    if (!this.formEmpresa.get('celular')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un número de celular", "info");
      this.inputCelular?.nativeElement.focus();
      return;
    }

    /* if (!this.formEmpresa.get('email')?.value) {
      this.mostrarAlerta("Campo requerido", "Por favor, ingresa un correo electronico", "info");
      this.inputEmail?.nativeElement.focus();
      return;
    } */

  if (!this.validarTipoEmpresaSeleccionado()) {
    return;
  }



    // Convertir los booleanos a 1 o 0 para los checkboxes
    const checkboxKeys = [
      'eps', 'arl', 'afp', 'ces', 'ccf', 'bancos', 'transporte', 'colegio',
      'cda', 'taller', 'eds', 'contratista', 'proveedor', 'aseguradora', 
      'almacen', 'serviteca', 'entidad'
    ];
    checkboxKeys.forEach(key => {
      datosEmpresas[key] = datosEmpresas[key] ? 1 : 0;
    });
  
    // Enviar datos al backend
    this.empresasService.createEmpresa(datosEmpresas).subscribe({
      next: () => {
        this.mostrarAlerta("Guardado exitoso", "La empresa ha sido creada correctamente.", "success");
        this.resetForm();  // Reinicia el formulario
      },
      error: (err) => this.mostrarAlerta("Error", err.message, "error")
    });
  }
  
  
  // Función para reiniciar el formulario
  resetForm() {
    this.formEmpresa.reset({
      nit: '', digito: '', nombre: '', direccion: '', ciudad: '', telefono: '',
      celular: '', email: '', observaciones: '', eps: false, arl: false, afp: false,
      ces: false, ccf: false, bancos: false, transporte: false, colegio: false, cda: false,
      taller: false, eds: false, contratista: false, proveedor: false, aseguradora: false,
      almacen: false, serviteca: false, entidad: false, estado: 1
    });
    this.validate = false;
    this.errores = null;
  }

  onSubmit() {
    if (this.formEmpresa.valid) {
      this.guardarEmpresas();
    } else {
      console.log('Formulario inválido');
    }
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({ title: titulo, text: mensaje, icon: icono, confirmButtonColor: "#3085d6" });
  }

   private cargarCiudades(): void {
    forkJoin({
          municipios: this.dataService.getDatos(),
         
        }).subscribe(
          (resultados) => {
            this.municipios = resultados.municipios;
           
          },
          (error) => this.handleError(error)
        );

   }
   // Manejo de errores genérico
   private handleError(error: any): void {
    console.error('Error al obtener datos:', error);
  }

  permitirSoloNumeros(event: KeyboardEvent): void {
  const charCode = event.key;
  if (!/^[0-9]$/.test(charCode)) {
    event.preventDefault();
  }
}

}